import React from "react";
import { Search } from "lucide-react";
import ReusableDropdown from "../../../../../components/ReusableDropdown";

const HolidayFilters = ({
  theme, isRTL, language, t,
  holidaySearch, onSearchChange,
  holidayClientFilter, onClientFilterChange,
  holidayCompanyFilter, onCompanyFilterChange,
  holidayClientsList, holidayCompanies, holidayList,
}) => {
  const inputBase = {
    borderRadius: "10px",
    border: `1px solid ${theme === "dark" ? "rgba(255,255,255,0.12)" : "#e5e7eb"}`,
    background: theme === "dark" ? "rgba(255,255,255,0.05)" : "#f9fafb",
    color: theme === "dark" ? "#fff" : "#111827",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box",
  };

  /* Build client items: prefer API list, fallback to unique values from holidayList */
  const clientItems = [
    { id: "", name: t.allClients },
    ...(holidayClientsList && holidayClientsList.length
      ? holidayClientsList.map((c) => {
          const name = typeof c === "string" ? c : (c.clientName || c.name || c);
          return { id: name, name };
        })
      : [...new Set(holidayList.map((h) => (h.clientName || "").toString().trim()).filter(Boolean))].map((name) => ({ id: name, name }))
    ),
  ];

  /* Build company items: prefer fetched list, fallback to holidayList values */
  const companyItems = [
    { id: "", name: t.allCompanies },
    ...((holidayCompanies && holidayCompanies.length)
      ? holidayCompanies.map((c) => {
          const name = typeof c === "string" ? c : (c.companyName || c.name || c.workingCompany || "");
          return { id: name, name };
        })
      : [...new Set(holidayList.map((h) => h.workingCompany).filter(Boolean))].map((co) => ({ id: co, name: co }))
    ),
  ];

  const dropdownInputStyle = {
    ...inputBase,
    padding: "9px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: "12px", marginBottom: "20px" }}>

      {/* Search */}
      <div style={{ position: "relative" }}>
        <Search size={14} style={{ position: "absolute", top: "50%", [isRTL ? "right" : "left"]: "12px", transform: "translateY(-50%)", color: "#9ca3af", pointerEvents: "none" }} />
        <input
          type="text"
          value={holidaySearch}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={isRTL ? "بحث..." : "Search..."}
          style={{
            ...inputBase,
            width: "100%",
            padding: `9px 12px 9px ${isRTL ? "12px" : "34px"}`,
            paddingRight: isRTL ? "34px" : "12px",
          }}
        />
      </div>

      {/* Client Filter */}
      <div>
        <ReusableDropdown
          items={clientItems}
          value={holidayClientFilter || ""}
          onChange={(id) => onClientFilterChange(id)}
          placeholder={t.selectClient}
          emptyMessage={t.noCompaniesFound}
          maxItems={100}
          getItemLabel={(item) => item.name || ""}
          theme={theme}
          language={language}
          inputStyle={dropdownInputStyle}
          showAllOnArrowClick={true}
          showClear={true}
        />
      </div>

      {/* Company Filter */}
      <div>
        <ReusableDropdown
          items={companyItems}
          value={holidayCompanyFilter || ""}
          onChange={(id) => onCompanyFilterChange(id)}
          placeholder={t.allCompanies}
          emptyMessage={t.noCompaniesFound}
          maxItems={100}
          getItemLabel={(item) => item.name || ""}
          theme={theme}
          language={language}
          inputStyle={dropdownInputStyle}
          showAllOnArrowClick={true}
          showClear={true}
        />
      </div>
    </div>
  );
};

export default HolidayFilters;